// Single source of truth for each site's public identity (name, canonical origin, icons, share image).
// Every site is its own brand: nothing here should ever fall back to the admin (AllMarketingMixed) identity
// on a consumer domain. `origin` must match the host the backend sitemap uses (services/bot_renderer SITES).
import siteConfig from '@/config/siteConfig';

export const SITE_BRANDS = {
  auto:    { name: 'CarsbikesPrices', origin: 'https://carsbikesprices.com',     prefix: '/auto',    favicon: '/favicon-auto',    og: '/og-auto.jpg',    themeColor: '#dc2626', accent: 'text-[hsl(10,80%,55%)]' },
  coupon:  { name: 'MetroMandi',      origin: 'https://metromandi.com',          prefix: '/coupons', favicon: '/favicon-coupon',  og: '/og-coupon.jpg',  themeColor: '#7c3aed', accent: 'text-[hsl(260,90%,60%)]' },
  finance: { name: 'YourMoneyWise',   origin: 'https://yourmoneywise.net',       prefix: '/finance', favicon: '/favicon-finance', og: '/og-finance.jpg', themeColor: '#059669', accent: 'text-emerald-600' },
  games:   { name: 'GamesNFans',      origin: 'https://www.gamesnfans.tv',       prefix: '/games',   favicon: '/favicon-games',   og: '/og-games.jpg',   themeColor: '#f59e0b', accent: 'text-yellow-400' },
  travel:  { name: 'WokeTraveler',    origin: 'https://woketraveler.com',        prefix: '/travel',  favicon: '/favicon-travel',  og: '/og-travel.jpg',  themeColor: '#0d9488', accent: 'text-teal-600' },
  tech:    { name: 'Tech-N-AI Talks', origin: 'https://tech-n-ai-talks.com',     prefix: '/tech',    favicon: '/favicon-tech',    og: '/og-tech.jpg',    themeColor: '#6366f1', accent: 'text-indigo-600' },
  vikas:   { name: 'Vikasifications', origin: 'https://www.vikasifications.com', prefix: '/vikas',   favicon: '/favicon-vikas',   og: '/og-vikas.jpg',   themeColor: '#111111', accent: 'text-black' },
  dgtg:    { name: 'DGTG',            origin: 'https://www.dgtg.in',             prefix: '/dgtg',    favicon: '/favicon-dgtg',    og: '/og-dgtg.jpg',    themeColor: '#773DFF', accent: 'text-[#773DFF]' },
  devmob:  { name: 'DevMob',          origin: 'https://devmob.co',               prefix: '/devmob',  favicon: '/favicon-devmob',  og: '/og-devmob.jpg',  themeColor: '#8b5cf6', accent: 'text-violet-600' },
  admin:   { name: 'AllMarketingMixed', origin: 'https://allmarketingmixed.com', prefix: '',         favicon: '/favicon-admin',   og: '/og-admin.jpg',   themeColor: '#111111', accent: 'text-gray-700' },
};

// Content is stored under 'vikasifications' in the CMS; everything else uses the site id directly.
const ALIASES = { vikasifications: 'vikas' };

// Effective site id. On a production domain this is always the domain's own site. The fallbacks only
// matter on localhost / preview ('all' mode), where the URL prefix tells us which site is being viewed.
export function currentSiteId(explicit) {
  if (explicit) return ALIASES[explicit] || explicit;
  if (siteConfig.siteId !== 'all') return siteConfig.siteId;
  if (typeof window !== 'undefined') {
    const p = window.location.pathname;
    for (const [id, b] of Object.entries(SITE_BRANDS)) {
      if (b.prefix && (p === b.prefix || p.startsWith(b.prefix + '/'))) return id;
    }
    try {
      const ref = sessionStorage.getItem('_site_entry');
      if (ref && SITE_BRANDS[ref]) return ref;
    } catch {}
  }
  return 'auto';
}

export function siteBrand(explicit) {
  const id = currentSiteId(explicit);
  return { id, ...(SITE_BRANDS[id] || SITE_BRANDS.auto) };
}

// Path of the site's home page as the visitor sees it: '/' on the site's own domain, '/<prefix>' in 'all' mode.
export function siteHomePath(id) {
  if (siteConfig.siteId !== 'all') return '/';
  return (SITE_BRANDS[id] && SITE_BRANDS[id].prefix) || '/';
}
